"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weights = exports.sizes = exports.THEME_NAME = void 0;
var THEME_NAME = 'typography';
exports.THEME_NAME = THEME_NAME;
var sizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl'
};
exports.sizes = sizes;
var weights = {
  "default": 'default',
  attention: 'attention',
  max: 'max'
};
exports.weights = weights;